import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export default styled.div`
  display: flex;
  padding: 4px;
  align-items: center;

  gap: 4px;
  align-self: center;
  width: 100%;
  height: auto;
  border-radius: 6px;

  .em-span {
    color: ${Theme.pallete.SENARY};

    font-family: ${Theme.fontFamily.SECONDARY};

    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .em-icon {
    max-width: 12px;
    max-height: 12px;
  }
`
